import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=07c5670c&component=true&componentId=index945f8446"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index945f8446"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=index945f8446"
import style0 from "./index.mpx?vue&type=style&index=0&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22m945f8446%22%7D&component=true&componentId=index945f8446"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports